import { LABEL_COLOR, LABEL_SIZE } from "../utils";
import { createSemanticTextComponent } from "./createSemanticTextComponent";
export var H1 = createSemanticTextComponent('h1', {
  fontSize: 'T700',
  color: 'neutral90',
  fontWeight: 'light',
  // Override user agent stylesheet
  margin: 0
});
export var H2 = createSemanticTextComponent('h2', {
  fontSize: 'T600',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
export var H3 = createSemanticTextComponent('h3', {
  fontSize: 'T500',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
export var H4 = createSemanticTextComponent('h4', {
  fontSize: 'T400',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
export var H5 = createSemanticTextComponent('h5', {
  fontSize: 'T300',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
export var H6 = createSemanticTextComponent('h6', {
  fontSize: 'T200',
  color: 'neutral90',
  fontWeight: 'regular',
  // Override user agent stylesheet
  margin: 0
});
export var P = createSemanticTextComponent('p', {
  fontSize: 'T300',
  color: 'neutral70',
  fontWeight: 'regular'
});
export var Label = createSemanticTextComponent('label', {
  fontSize: LABEL_SIZE,
  color: LABEL_COLOR,
  fontWeight: 'regular'
});
export var Span = createSemanticTextComponent('span', {
  display: 'inline'
});
export var Code = createSemanticTextComponent('code', {
  display: 'inline',
  backgroundColor: 'neutral05'
});